import { Button, Modal, Stack, styled } from '@ltvco/refresh-lib/theme';

export const StyledIntroModal = styled(Modal)(({ theme }) => ({
  '.MuiDialog-paper': {
    width: '720px',
    maxWidth: '92vw',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    border: `2px solid ${theme.palette.primary.main}`,
  },
}));

export const ModalContent = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  alignItems: 'center',
  textAlign: 'center',
}));

export const PrimaryPillButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  borderRadius: 100,
  padding: theme.spacing(1, 3),
}));
